export interface searchPointData{
  Type:number;
  Name:string;
  PropertyAddress:string;
  Latitude:number;
  Longitude:number;
  Radiuskm:number;
  Radius?:number;
  geocode?:any;
};
